import React, {useState} from 'react';
import {useTranslation} from '../../context/language';
import {
  Container,
  LogoContainer,
  TitleContainer,
  Title,
  BottomContainer,
  TextContainer,
  Text,
  DataContainer,
  ButtonContainer,
  Button,
} from './styles';
import Logo from '../../components/atoms/Logo';
import {theme} from '../../styles/darkTheme';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../redux/reducers';
import {useNavigate} from 'react-router-dom';
import axios from '../../utils/axios';
import LoadingSpinner from '../../components/atoms/LoadingSpinner';
import {UserState} from '../../redux/reducers/user';
import {SET_USER} from '../../redux/actionTypes';

const ConfirmRegistry = () => {
  const {text, title} = useTranslation();
  const history = useNavigate();
  const {
    firstName,
    middleName,
    firstLastName,
    secondLastName,
    birthDate,
    city,
    province,
    dialCountryCode,
    mobileNumber,
  } = useSelector((state: RootState) => ({...state.registry, ...state.user}));
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const formatDate = () => {
    const date = birthDate.split('-');
    if (date.length < 3) return birthDate;
    return `${date[2]}/${date[1]}/${date[0]}`;
  };

  const saveUser = (data: any) => {
    const {
      firebase_uid,
      id,
      phoneNumber,
      dialCountryCode,
      streamToken,
      profile,
    } = data;
    const currentUser: UserState = {
      id,
      dialCountryCode: dialCountryCode,
      mobileNumber: phoneNumber,
      streamToken: streamToken,
      profile,
    };
    dispatch({type: SET_USER, payload: currentUser});
  };

  const handleSubmit = async () => {
    const url = 'api/v1/user/widget/profile/';
    const data = {
      firstName,
      firstNameSecond: middleName,
      lastName: firstLastName,
      lastNameSecond: secondLastName,
      birthDate,
      city,
      province,
      userPhone: {
        dialCountryCode,
        mobileNumber,
      },
    };

    try {
      setIsLoading(true);
      const res = await axios.post(url, data);
      setIsLoading(false);
      if (res.data) {
        saveUser(res.data);
        history('/welcome');
      }
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Container theme={theme}>
          <LogoContainer>
            <Logo height={120} width={300} />
          </LogoContainer>
          <TitleContainer>
            <Title theme={theme}>{title.welcome}</Title>
          </TitleContainer>
          <BottomContainer theme={theme}>
            <TextContainer>
              <Text theme={theme}>{text.confirmRegistry}</Text>
            </TextContainer>
            <DataContainer theme={theme}>
              <Text theme={theme} opacity={0.7}>
                {text.firstName}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {firstName}
                </Text>
              </Text>
              <Text theme={theme} opacity={0.7}>
                {text.middleName}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {middleName}
                </Text>
              </Text>
              <Text theme={theme} opacity={0.7}>
                {text.firstLastName}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {firstLastName}
                </Text>
              </Text>
              <Text theme={theme} opacity={0.7}>
                {text.secondLastName}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {secondLastName}
                </Text>
              </Text>
              <Text theme={theme} opacity={0.7}>
                {text.birthDate}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {formatDate()}
                </Text>
              </Text>
              <Text theme={theme} opacity={0.7}>
                {text.city}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {city}
                </Text>
              </Text>
              <Text theme={theme} opacity={0.7}>
                {text.province}:{' '}
                <Text theme={theme} bold opacity={0.7}>
                  {province}
                </Text>
              </Text>
            </DataContainer>
            <ButtonContainer>
              <Button
                back
                textColor={theme.secondary}
                onClick={() => history(-1)}>
                {text.edit}
              </Button>
              <Button onClick={handleSubmit}>{text.continue}</Button>
            </ButtonContainer>
          </BottomContainer>
        </Container>
      )}
    </>
  );
};

export default ConfirmRegistry;
